<template lang="pug">
  .company-details(v-if="content")
    .page__wr
      Bread(v-if="content.bread", :bread="content.bread")
      .company-details__title(v-if="h1") {{h1}}
      h3.company-details__subtitle(v-if="content.subtitle") {{ content.subtitle }}
      .company-details__address(v-if="content.address")
        .company-details__address-item(v-for="(item, index) in content.address" :key="index")
          .company-details__address-item-title(v-if="item.title") {{ item.title }}
          .company-details__address-item-text(v-if="item.text") {{ item.text }}
      .company-details__details
        .company-details__details-item(v-for="(item, index) in content.details" :key="index")
          span.company-details__details-item-title(v-if="item.title") {{ item.title }}
          p.company-details__details-item-text(v-if="item.text") {{ item.text }}
        .company-details__details-item-block
          p.company-details__details-item-text(v-if="content.bank") {{ content.bank }}
          p.company-details__details-item-text(v-if="content.direction") {{ content.director }}
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/companyDetails/companyDetails.styl';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import Bread from '@/components/common/bread/bread.vue';

  export default {
    name: 'CompanyDetails',

    mixins: [AjaxHelpersVue],

    data() {
      return {
        content: null
      }
    },

    components: {
      SvgIcon,
      Bread
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadCompanyDetailsPage', params => {
        this.request(params.url);
      });
    },

    methods: {
      request(url) {
        this.req('CompanyDetailsPage:getCompanyDetailsPage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;

            this.$nextTick(() => {

            })
          }
        }, 'company-details');
      },
    }

  }
</script>
